import { Routes } from '@angular/router';

export const CONTENT_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('../../modules/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('../../modules/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'user',
    loadChildren: () => import('../../modules/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'occupation',
    loadChildren: () => import('../../modules/occupation/occupation.module').then(m => m.OccupationModule)
  },
  {
    path: 'operation',
    loadChildren: () => import('../../modules/operation/operation.module').then(m => m.OperationModule)
  },
  {
    path: 'role',
    loadChildren: () => import('../../modules/role/role.module').then(m => m.RoleModule)
  },
  {
    path: 'car',
    loadChildren: () => import('../../modules/car/car.module').then(m => m.CarModule)
  },
  {
    path: 'slack-city-channel',
    loadChildren: () => import('../../modules/slack-city-channel/slack-city-channel.module').then(m => m.SlackCityChannelModule)
  },
  {
    path: 'time-card',
    loadChildren: () => import('../../modules/time-card/time-card.module').then(m => m.TimeCardModule)
  },
  {
    path: 'map',
    loadChildren: () => import('../../modules/map/map.module').then(m => m.MapsModule)
  },
  {
    path: 'navigation',
    loadChildren: () => import('../../modules/navigation/navigation.module').then(m => m.NavigationModule)
  },
  {
    path: 'input',
    loadChildren: () => import('../../modules/input-form/input-form.module').then(m => m.InputFormModule)
  },
  {
    path: 'route-list',
    loadChildren: () => import('../../modules/driver-route-list/driver-route-list.module').then(m => m.DriverRouteListModule)
  },
  {
    path: 'new-city',
    loadChildren: () => import('../../modules/new-city/new-city.module').then(m => m.NewCityModule)
  },
  {
    path: 'stat',
    loadChildren: () => import('../../modules/stat/stat.module').then(m => m.StatModule)
  },
  {
    path: 'rental',
    loadChildren: () => import('../../modules/rental/rental.module').then(m => m.RentalModule)
  },
  {
    path: 'export',
    loadChildren: () => import('../../modules/export/export.module').then(m => m.ExportModule)
  },
  {
    path: 'comp-taskqueue',
    loadChildren: () => import('../../modules/comp-taskqueue/comp-taskqueue.module').then(m => m.CompTaskqueueModule)
  },
  {
    path: 'personal-leave-request',
    loadChildren: () => import('../../modules/personal-leave-request/personal-leave-request.module').then(m => m.PersonalLeaveRequestModule)
  },
  {
    path: 'customer',
    loadChildren: () => import('../../modules/customer/customer.module').then(m => m.CustomerModule)
  },
  {
    path: 'rental',
    loadChildren: () => import('../../modules/rental/rental.module').then(m => m.RentalModule)
  },
  {
    path: 'workshop',
    loadChildren: () => import('../../modules/workshop/workshop.module').then(m => m.WorkshopModule)
  },
  {
    path: 'issue',
    loadChildren: () => import('../../modules/issue/issue.module').then(m => m.IssueModule)
  },
  {
    path: 'issue-time-log',
    loadChildren: () => import('../../modules/issue-time-log/issue-time-log.module').then(m => m.IssueTimeLogModule)
  },
  {
    path: 'place',
    loadChildren: () => import('../../modules/place/place.module').then(m => m.PlaceModule)
  },
  {
    path: 'error',
    loadChildren: () => import('../../modules/error/error.module').then(m => m.ErrorModule)
  },
];
